import React, { useEffect, useMemo, useState } from "react"
import { filterOptions } from "./utils"
// import { Cascader, Popup } from "antd-mobile-v5"

import modStyl from "./index.module.scss"
import { Toast } from "antd-mobile"
import Cascader from "./cascader"

export interface Properties {
  // 区域之间的分隔符
  separator?: string
  // 选择地区层级 1 - 省，2 - 市，3 - 区
  level?: 1 | 2 | 3
  // 是否显示已禁用地区（默认显示为禁用状态）
  display?: boolean
  // 包含以下地区（填写省份则整个省份下的城市可选，2者同时配置优先includes）
  includes?: string[][]
  // 排除以下地区（填写省份则整个省份下的城市不可选择）
  excludes?: string[][]
}

export type RegionSelectActions = {
  getModifyValue: (value?: string)=> void
}

interface RegionSelectProps {
  value?: string
  placeholder?: string
  onChange?: (value: string)=> void
  properties?: Properties
}

const RegionSelect: React.FC<RegionSelectProps> = ({ value, placeholder, properties = {}, onChange })=> {

  const [visible, setVisible] = useState(false)

  const [shadow, setShadow] = useState<string[]>([])

  const options = useMemo(()=> filterOptions(properties), [])

  const { separator = '/', level = 2 } = properties

  const handleChange = (values: string[])=> {
    if (values.length != level) {
      Toast.show('请选择完整的地区')
      return
    }
    setShadow(values)
    onChange?.(values.join(separator))
    setVisible(false)
  }

  useEffect(()=> {
    setShadow(value ? value.split(separator) : [])
  }, [value])

  return (
    <>
    <button className={modStyl.trigger} onClick={()=> setVisible(true)} type="button">
      {
        value || shadow.length > 0 ? <span className={modStyl.value}>{value}</span> : <span>{placeholder}</span>
      }
    </button>
    <Cascader options={options} visible={visible} value={shadow} onConfirm={handleChange} onCancel={()=> setVisible(false)}/>
    </>
  )
}

export default RegionSelect